var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge",class:_vm.settings.enabled ? 'badge-success' : 'badge-neutral'},[_vm._v("\n  "+_vm._s(_vm.settings.enabled ? 'On' : 'Off')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }